"use client";

import ImageOverlay from "@/components/image-overlay";
import clsx from "clsx";
import { motion } from "framer-motion";

export interface BannerProps {
  bannerUrl: string;
  bannerMobileUrl?: string;
  bannerTiltle: string;
}

export default function Banner(props: BannerProps) {
  return (
    <div className="h-svh xl:h-[calc(100vh-var(--navbar-height))] relative xl:mt-20">
      <ImageOverlay
       lazy={false}
        src={props.bannerUrl}
        alt="hero"
        className="w-full h-svh hidden lg:block xl:h-[calc(100vh-var(--navbar-height))] object-cover"
        fetchPriority="high"
      />

      {props.bannerMobileUrl && (
        <ImageOverlay
         lazy={false}
          src={props.bannerMobileUrl}
          alt="hero"
          className="w-full max-w-full h-svh block lg:hidden object-cover"
          fetchPriority="high"
        />
      )}

      <button
        className={clsx(
          "w-24 h-24 rounded-full hidden xl:inline-flex justify-center items-center border border-white absolute left-1/2 -translate-x-1/2 bottom-6 z-[2]"
        )}
      >
        <div className="bg-white rounded-full flex justify-center items-center w-16 h-16">
          <motion.div
            animate={{
              y: [0, 10, 0],
            }}
            transition={{
              duration: 1.5,
              ease: "linear",
              repeat: Number.POSITIVE_INFINITY,
              repeatType: "loop",
            }}
          >
            <img
              className="w-8 h-8"
              width={32}
              height={32}
              src="/arrow-down.svg"
              alt="chevron-down"
            />
          </motion.div>
        </div>
      </button>

      <div className="absolute top-1/2 left-1/2 xl:left-0 -translate-x-1/2 xl:translate-x-0 w-full z-30">
        <div className="w-full xl:max-w-screen-xl mx-auto">
          <h1
            style={{
              textShadow: "0px 4px 4px rgba(0, 0, 0, 0.45)",
            }}
            className="text-white text-center xl:text-left text-2xl md:text-[40px] xl:text-6xl font-pluto xl:leading-12 px-8 xl:px-0"
            dangerouslySetInnerHTML={{
              __html: props.bannerTiltle.replaceAll("<br/>", "\n"),
            }}
          ></h1>
        </div>
      </div>
    </div>
  );
}
